module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.render) ? _c('div', {
    staticClass: "d-flex justify-center align-center wrap flex-column success-page"
  }, [_c('img', {
    staticClass: "sp-confetti",
    attrs: {
      "src": require("../../assets/img/confetti.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ty-d2d"
  }, [_vm._v("\n    Thank you for booking with us!\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "trip-details-box"
  }, [_c('div', {
    staticClass: "td-head"
  }, [_c('div', {
    staticClass: "td-field"
  }, [_c('div', [_vm._v("Hotel:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.selected.HotelName))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', [_vm._v("Booking ID:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.commitData.BookingDetails.BookingId))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', [_vm._v("Booking Ref NO:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.commitData.BookingDetails.BookingRefNo))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', [_vm._v("Date:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.dateFormat(_vm.hotel.date.start)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "home-link"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back to Home page")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-copy"
  }, [_c('span', [_vm._v("We've sent you an email with the details.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4883c985", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4883c985","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DHotel/thankyou.vue
// module id = 2081
// module chunks = 0